module.exports = __webpack_public_path__ + "assets/img/swiper-img4-f0d9166c.png";